import { render, staticRenderFns } from "./addmanges.vue?vue&type=template&id=970b6706&scoped=true"
import script from "./addmanges.vue?vue&type=script&lang=js"
export * from "./addmanges.vue?vue&type=script&lang=js"
import style0 from "./addmanges.vue?vue&type=style&index=0&id=970b6706&prod&lang=less&scoped=true"
import style1 from "./addmanges.vue?vue&type=style&index=1&id=970b6706&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970b6706",
  null
  
)

export default component.exports